export enum SkateType{
    PROFESSIONAL = 'PROFESIONAL',
    AMATEUR = 'RECREATIVO',
    TRADITIONAL = 'TRADICIONAL',
    NA = 'N/A'
}